import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    width: 480,
    padding: theme.spacing(3),
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  title: {
    fontWeight: 500,
    paddingRight: theme.spacing(4),
  },
  alert: {
    marginTop: theme.spacing(3),
  },
  checkboxRow: {
    marginTop: theme.spacing(2),
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
}));
